import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing custom components
import { IconButton } from '../../core/icon-button';
import { Tooltip } from '../../core/tooltip';
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
import { useTranslation } from 'react-i18next';
// Importing icons
import MutedIcon from '@mui/icons-material/VolumeOffRounded';
import VolumeIcon from '@mui/icons-material/VolumeUpRounded';
// Importing store
import { usePlayerStore } from '../../../store/player.store';
// Importing 3rd party components
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
// ----------------------------------------------------------------------
export const VolumeControls = () => {
    // Adding hooks
    const { t } = useTranslation();
    // Adding data handler
    const { muted, volume, volumeHover, setMuted, setVolume, setVolumeHover } = usePlayerStore(useShallow((state) => ({
        muted: state.muted,
        volume: state.volume,
        volumeHover: state.volumeHover,
        setMuted: state.setMuted,
        setVolume: state.setVolume,
        setVolumeHover: state.setVolumeHover,
    })));
    // Adding callback to handle volume changes
    const handleVolumeChange = (event, value) => {
        setVolume(value);
    };
    return (_jsxs(Box, { display: { xs: 'none', sm: 'flex' }, flexDirection: "row", alignItems: "center", onMouseEnter: setVolumeHover, onMouseLeave: setVolumeHover, children: [_jsx(Tooltip, { title: t('player:controls:volume:title'), children: _jsx(IconButton, { "aria-label": "volume", onClick: setMuted, children: muted ? _jsx(MutedIcon, {}) : _jsx(VolumeIcon, {}) }) }), (volumeHover || muted) && (_jsx(Slider, { "aria-label": "Volume", max: 1, min: 0, size: "small", step: 0.01, sx: {
                    height: 4,
                    ml: 1,
                    mr: 1,
                    width: 60,
                    animation: 'sliderFade 0.25s forwards',
                    '@keyframes sliderFade': {
                        '0%': { opacity: 0 },
                        '100%': { opacity: 1 },
                    },
                    '& .MuiSlider-rail': {
                        backgroundColor: 'white',
                        opacity: 0.3,
                    },
                }, value: volume, onChange: handleVolumeChange }))] }));
};
